export const titleCase = (str: unknown) => {
	return String(str)
		.replace(/_/g, " ")
		.split(" ")
		.map((item) => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase())
		.join(" ");
};
